import { Link } from 'react-router-dom';
import { preloadProjectImages } from '@/utils/preloadProjectImages';

// Art 列表页的单个项目卡片。priority 用于首屏封面，提升关键图片加载优先级。
export default function ProjectCard({ project, featured = false, priority = false }) {
  const handleIntentToOpen = () => {
    preloadProjectImages(project);
  };

  return (
    <article className={`art-project-card${featured ? ' art-project-card--featured' : ''}`}>
      <Link
        to={`/art/${project.slug}`}
        className="art-project-link"
        onFocus={handleIntentToOpen}
        onMouseEnter={handleIntentToOpen}
        onTouchStart={handleIntentToOpen}
      >
        <div className="art-project-media">
          <img
            loading={priority ? 'eager' : 'lazy'}
            decoding="async"
            fetchPriority={priority ? 'high' : 'auto'}
            src={project.cover}
            alt={project.title}
            className="art-project-image"
          />
        </div>
        <div className="art-project-meta">
          <div>
            <h2 className="art-project-title">{project.title}</h2>
            <p className="art-project-info">{project.info}</p>
          </div>
          <p className="art-project-excerpt">{project.excerpt}</p>
        </div>
      </Link>
    </article>
  );
}
